import { useNavigate } from "react-router-dom";
import { AbsoluteCenter, Box, Heading, Stack, Text, Image, Button, VStack } from "@chakra-ui/react";

import rejectedImage from "../../../../assets/rejected.png";

export function LimitReject() {
  const navigate = useNavigate();

  return (
    <Box position="relative" h="calc(100vh - 84px * 2)">
      <AbsoluteCenter axis="both">
        <Stack spacing={4} minW="300px">
          <div><Heading textAlign="center">К сожалению, отказ</Heading></div>
          <Text size="sm" align="center">
            На данный момент лимит не может
            <br />
            быть одобрен
          </Text>
          <VStack spacing={[20]} mt={6}>
            <Image src={rejectedImage} width="150px" />
            <Button onClick={() => { navigate("/"); }} colorScheme="brand" w="100%">
              Закрыть
            </Button>
          </VStack>
        </Stack>
      </AbsoluteCenter>
    </Box>
  );
}
